import { Controller } from "@hotwired/stimulus"

// Auto-shows the dialog as soon as the menu target mounts inside the
// persistent turbo-frame, and owns the full close path so re-opening
// works: on close, clears src on the parent <turbo-frame> and removes
// the dialog node from the DOM.
export default class extends Controller {
  static targets = ["modal", "menu"]

  menuTargetConnected() {
    this.menuTarget.showModal()
  }

  hideModal() {
    this.element.parentElement.removeAttribute("src")
    this.modalTarget.remove()
  }

  submitEnd(e) {
    if (e.detail.success) this.hideModal()
  }

  // Only the modal's own backdrop closes it. A nested <dialog> (the delete
  // confirm) bubbles its backdrop mousedown here with itself as target.
  closeOnClickOutside({ target }) {
    if (target === this.menuTarget) this.hideModal()
  }
}
